import { Like } from '@model/like';
import { User } from '@model/user/user';
import { LikeableTypeIdentifier } from '@type/likeable-type-identifier';

export interface Likeable {
  likeableTypeIdentifier: LikeableTypeIdentifier;

  id: number;
  count_likes: number;
  likes: Like[];
  frontend_user: User;
  likeable: boolean;
}

export function instanceOfLikeable(object: any): object is Likeable {
  return 'likeableTypeIdentifier' in object;
}
